<i18n>
{
  "fr": {
    "configuratorAddCustomizationDropdownMenu": {
      "trigger": {
        "label": "Ajouter un contenu",
        "title": "@:configuratorAddCustomizationDropdownMenu.trigger.label"
      },
      "action": {
        "addText": {
          "label": "Texte",
          "title": "Ajouter un texte"
        },
        "addImage": {
          "label": "Image",
          "title": "Ajouter une image"
        }
      }
    }
  }
}
</i18n>

<template>
  <BaseDropdown
    v-model="computedIsExpanded"
    class="configurator-add-customization-dropdown-menu"
    fit-parent
    v-bind="{
      modalBreakpoint: Breakpoint.CONFIGURATOR_XS,
      modalTargetSlot: 'body',
      modalClass: 'configurator-add-customization-dropdown-menu__modal',
      dropdownTargetClass:
        'configurator-add-customization-dropdown-menu__target-wrapper',
      modalOptions: {
        hideCloseButton: true,
      },
    }"
  >
    <template #trigger="{ toggleState }">
      <ConfiguratorBtnDropdownTrigger
        :label="$t('configuratorAddCustomizationDropdownMenu.trigger.label')"
        @click="toggleState"
      />
    </template>

    <template #target>
      <ul class="configurator-add-customization-dropdown-menu__action-list">
        <li
          v-for="action in actions"
          :key="action.id"
          class="configurator-add-customization-dropdown-menu__action-item"
        >
          <button
            class="configurator-add-customization-dropdown-menu__action-item-btn"
            type="button"
            :title="action.title"
            @click="onActionClick(action.id)"
            v-text="action.label"
          ></button>
        </li>
      </ul>
    </template>
  </BaseDropdown>
</template>

<script>
import BaseDropdown from '../BaseDropdown';
import { ZoneType } from '../../api/static/zones';
import { Breakpoint } from '../../utils/breakpoints';
import ConfiguratorBtnDropdownTrigger from './ConfiguratorBtnDropdownTrigger';

export default {
  name: 'ConfiguratorAddCustomizationDropdownMenu',
  components: { ConfiguratorBtnDropdownTrigger, BaseDropdown },
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    isExpanded: Boolean,
    allowTextCustomizations: Boolean,
    allowImageCustomizations: Boolean,
  },
  data() {
    return {
      localIsExpanded: false,
      Breakpoint,
    };
  },
  computed: {
    computedIsExpanded: {
      get() {
        return this.localIsExpanded;
      },
      set(isExpanded) {
        this.localIsExpanded = isExpanded;

        this.$emit('change', isExpanded);
      },
    },
    actions() {
      const actionList = [];

      if (this.allowTextCustomizations) {
        actionList.push({
          id: ZoneType.TEXT,
          label: this.$t(
            'configuratorAddCustomizationDropdownMenu.action.addText.label'
          ),
          title: this.$t(
            'configuratorAddCustomizationDropdownMenu.action.addText.title'
          ),
        });
      }

      if (this.allowImageCustomizations) {
        actionList.push({
          id: ZoneType.IMAGE,
          label: this.$t(
            'configuratorAddCustomizationDropdownMenu.action.addImage.label'
          ),
          title: this.$t(
            'configuratorAddCustomizationDropdownMenu.action.addImage.title'
          ),
        });
      }

      return actionList;
    },
  },
  watch: {
    isExpanded: {
      handler(isExpanded) {
        this.localIsExpanded = isExpanded;
      },
      immediate: true,
    },
  },
  methods: {
    onActionClick(action) {
      this.$emit('action-click', action);

      this.computedIsExpanded = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.configurator-add-customization-dropdown-menu {
  display: inline-flex;
  width: 100%;
  justify-content: center;

  &__action-list {
    margin-bottom: 0;
    padding-left: 0;
    margin-left: 0;
  }

  &__action-item-btn {
    display: flex;
    width: 100%;
    cursor: pointer;
    font: inherit;
    background: none;
    border: 0;
    padding: 0.5em 1em;
    margin: 0;
    transition: background-color $default-transition-duration;

    &:hover {
      background-color: $color-gray-whild-sand;
    }
  }
}
</style>

<style lang="scss">
.configurator-add-customization-dropdown-menu {
  &__target-wrapper {
    color: $color-gray-dove;
    border: solid 1px $color-primary;
    border-radius: 0.5em;
    background-color: $color-white;
    overflow: hidden;
  }

  &__modal {
    .base-modal__body {
      background-color: $color-white;
    }

    .base-modal__container {
      min-width: 15em;
    }
  }
}
</style>
